import { AccessToken, ExportJob } from 'common-models';
import { eventsApiSlice } from '../events/eventsApiSlice';

interface CreateExportRequest {
  eventIds: string[];
  accessToken: AccessToken;
}

interface GetExportJobRequest {
  jobId: string;
  accessToken: AccessToken;
}

const adminExportsApiSlice = eventsApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createExportJob: builder.mutation<ExportJob, CreateExportRequest>({
      query: ({ eventIds, accessToken }) => ({
        url: '/admin/exports',
        method: 'POST',
        body: { eventIds },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    }),

    getExportJob: builder.query<ExportJob, GetExportJobRequest>({
      query: ({ jobId, accessToken }) => ({
        url: `/admin/exports/${jobId}`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateExportJobMutation,
  useLazyGetExportJobQuery,
} = adminExportsApiSlice;
